<template>
    <div class="tds-checkbox" @click.prevent="$emit('update:activated', !activated)">
        <span class="checkbox" :class="activated ? 'activated' : ''">✓</span>
        <label>
            <slot></slot>
        </label>
    </div>
</template>

<script lang="ts">
import {Component, Prop, Vue} from "vue-property-decorator";

@Component
export default class TDSCheckbox extends Vue{
    @Prop({type: Boolean, default: false}) activated!: boolean;
}
</script>

<style lang="scss" scoped>
    //@import "../../styles/variables.scss";

    div.tds-checkbox {

        &:hover {
            cursor: pointer;
        }

        label {
            //@include fontBody;
            display: inline-block;
            margin: 0 0 0 8px;

            &:hover {
                cursor: pointer;
            }
        }

        .checkbox {
            background-color: $highlightColorShade1;
            border-radius: 5px;
            border: 2px solid $highlightColor;
            height: 20px;
            width: 20px;
            display: inline-block;
            color: transparent;
            font-size: 16px;
            line-height: 14px;
            text-align: center;
            font-weight: 900;
            transition: color 0.15s ease-in-out 0s, background-color 0.15s ease-in-out 0.15s;

            &.activated {
                background-color: $highlightColor;
                color: white;
                transition: color 0.15s ease-in-out 0.15s, background-color 0.15s ease-in-out 0s;
            }

            &:hover {
                cursor: pointer;
            }
        }
    }
</style>
